/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OptimizeRouteRequest
 */
export interface OptimizeRouteRequest {
  /**
   *
   * @type {string}
   * @memberof OptimizeRouteRequest
   */
  companyListId: string;
  /**
   *
   * @type {Array<string>}
   * @memberof OptimizeRouteRequest
   */
  companyListItemIds: Array<string>;
  /**
   *
   * @type {number}
   * @memberof OptimizeRouteRequest
   */
  startLatitude: number;
  /**
   *
   * @type {number}
   * @memberof OptimizeRouteRequest
   */
  startLongitude: number;
  /**
   *
   * @type {number}
   * @memberof OptimizeRouteRequest
   */
  endLatitude?: number | null;
  /**
   *
   * @type {number}
   * @memberof OptimizeRouteRequest
   */
  endLongitude?: number | null;
}

/**
 * Check if a given object implements the OptimizeRouteRequest interface.
 */
export function instanceOfOptimizeRouteRequest(
  value: object,
): value is OptimizeRouteRequest {
  if (!("companyListId" in value) || value["companyListId"] === undefined)
    return false;
  if (
    !("companyListItemIds" in value) ||
    value["companyListItemIds"] === undefined
  )
    return false;
  if (!("startLatitude" in value) || value["startLatitude"] === undefined)
    return false;
  if (!("startLongitude" in value) || value["startLongitude"] === undefined)
    return false;
  return true;
}

export function OptimizeRouteRequestFromJSON(json: any): OptimizeRouteRequest {
  return OptimizeRouteRequestFromJSONTyped(json, false);
}

export function OptimizeRouteRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OptimizeRouteRequest {
  if (json == null) {
    return json;
  }
  return {
    companyListId: json["companyListId"],
    companyListItemIds: json["companyListItemIds"],
    startLatitude: json["startLatitude"],
    startLongitude: json["startLongitude"],
    endLatitude: json["endLatitude"] == null ? undefined : json["endLatitude"],
    endLongitude:
      json["endLongitude"] == null ? undefined : json["endLongitude"],
  };
}

export function OptimizeRouteRequestToJSON(json: any): OptimizeRouteRequest {
  return OptimizeRouteRequestToJSONTyped(json, false);
}

export function OptimizeRouteRequestToJSONTyped(
  value?: OptimizeRouteRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyListId: value["companyListId"],
    companyListItemIds: value["companyListItemIds"],
    startLatitude: value["startLatitude"],
    startLongitude: value["startLongitude"],
    endLatitude: value["endLatitude"],
    endLongitude: value["endLongitude"],
  };
}
